import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AdminComponent } from '../admin/admin.component';
import { EnquiryTypeComponent } from './enquiry-type/enquiry-type.component';
import { VisitorComponent } from './visitor/visitor.component';
import { ReceptionComponent } from './reception/reception.component';
import { AppointmentComponent } from './appointment/appointment.component';
import { IssuedProspectusComponent } from './issued-prospectus/issued-prospectus.component';


const routes: Routes = [

  { 
    path: '', 
    component: AdminComponent,
    children: [
      { path: 'enqenquirytype', component:EnquiryTypeComponent, pathMatch: 'full'},
      { path: 'enqvisitor', component:VisitorComponent, pathMatch: 'full'},     
      { path: 'enqreception', component:ReceptionComponent, pathMatch: 'full'},
      { path: 'enqappointment', component:AppointmentComponent, pathMatch: 'full'},
      { path: 'enqissuedprospectus', component:IssuedProspectusComponent, pathMatch: 'full'},
    ]
  }

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ReceptionRoutingModule { }
